<div class="list-item">
  <div class="details">
    <div class="icon-name">
      <rt-icon name="attach-file" margin-right-small-xx colorToken="colorIconLowDefault"></rt-icon>
      {{ attachmentPlaceloader.filename }}
      @if (attachmentPlaceloader.fileSize) {
        <span text-light class="size">({{ attachmentPlaceloader.fileSize | rtFileSize }})</span>
      }
    </div>
    @if (attachmentPlaceloader.isLoading) {
      <rt-spinner class="attachment-spinner" variant="small" margin-right-small-xx></rt-spinner>
    }
  </div>
  @if (attachmentPlaceloader.errorMessage) {
    <span class="error" padding-lr margin-left>{{ attachmentPlaceloader.errorMessage }}</span>
  }
  <rt-divider variant="line dark" margin-top-small> </rt-divider>
</div>
